
import spendGameManager from "../../manager/spendGameManager";
import {SpendModeEventI} from "../../config/SpendInterface";
import O1HD from "../../../../engines/gameEngine";
import DreamHousePrefab from "../DreamHousePrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class NpcDreamHouseItem extends cc.Component {

    @property({type:cc.Sprite,displayName:"npc精灵"})
    npcSpirit : cc.Sprite = null;
    @property(cc.Label)
    dialogLabel: cc.Label = null;

    private mGameLayer : spendGameManager;
    private mDeskIndex : number;//桌子下标
    private mSpendModeEventI : SpendModeEventI;//事件

    private talkMsgStr : string;
    private mParentScript : DreamHousePrefab;


    onLoad () {
        O1HD.emit("NpcDreamHouseItem.npcLeave" , this.npcLeave , this );
    }

    start () {
    }

    bindData( gameLayer : spendGameManager , deskIndex : number , spendModeEventI : SpendModeEventI ,parentScript : DreamHousePrefab){
        this.mGameLayer = gameLayer;
        this.mDeskIndex = deskIndex;
        this.mSpendModeEventI = spendModeEventI;
        this.mParentScript = parentScript;

        this._loadNpc();
        switch ( this.mDeskIndex ) {
            case 0:
                this.node.setPosition( cc.v2(-212.5,0) );
                break;
            case 1:
                this.node.setPosition( cc.v2(-0,0) );
                break;
            case 2:
                this.node.setPosition( cc.v2(212.5,0) );
                break;
        }

        this.talkMsgStr = `我是${this.mSpendModeEventI.belongNpc},${this.mSpendModeEventI.simpleDesc}`;
    }

    private _loadNpc(){
        let picUrl : string = this.mSpendModeEventI.belongNpc;
        // switch ( this.mSpendModeEventI.belongNpc ) {
        //     case "大姑":
        //         picUrl = "八大姨";
        //         break;
        //     case "二姑":
        //         picUrl = "发小";
        //         break;
        //     case "三姑":
        //         picUrl = "周某人";
        //         break;
        // }
        // O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/Image/npc/${picUrl}`,cc.SpriteFrame , ( error, assets : cc.SpriteFrame )=>{
        //     if ( error ) {
        //         console.log("NPC item load fail");
        //         return;
        //     }
        //     this.npcSpirit.spriteFrame = assets;
        // })
    }

    startTalk( callBack ){
        this.dialogLabel.node.parent.active = true;
        this.dialogLabel.node.parent.opacity = 255;
        this.dialogLabel.string = ``;
        this.talkMsg( callBack );
    }


    talkMsg( callBack ){
        if ( this.dialogLabel.string == this.talkMsgStr ){
            this.scheduleOnce(()=>{
                cc.tween( this.dialogLabel.node.parent )
                    .to( 1 , {opacity : 50 })
                    .call(()=>{
                        this.dialogLabel.node.parent.active = false;
                        callBack && callBack();
                    })
                    .start();
            },1);
            return;
        }
        this.scheduleOnce( ()=>{
            this.dialogLabel.string = this.talkMsgStr.substr( 0 , this.dialogLabel.string.length + 1 );
            this.talkMsg( callBack );
        },0.05 );
    }

    /**
     *
     */
    onBtnClick(){
        this.mGameLayer.mGameLayer.openOneEvent( this.mSpendModeEventI.id , ( eventEnd)=>{
            if ( eventEnd == 1 ) {
                // 判断是否满足 出去的条件
                this.mParentScript.checkCanBack();
                O1HD.emit("DreamHousePrefab.removeNpc" ,this.mSpendModeEventI.belongNpc );
                this.node.removeFromParent();
                this.node.destroy();
            }else{
                if ( this.mGameLayer.getGameData()._gameDays != 0 ) {
                    //不是第一天
                    O1HD.emit("DreamHousePrefab.removeNpc" , this.mSpendModeEventI.belongNpc );
                    this.node.removeFromParent();
                    this.node.destroy();
                }
            }
        });
    }


    /**
     * npc离开
     */
    npcLeave( npc ){
        if ( this.mSpendModeEventI.belongNpc == npc ) {
            this.mParentScript.checkCanBack();
            O1HD.emit("DreamHousePrefab.removeNpc", npc );
            this.node.removeFromParent();
            this.node.destroy();
        }
    }
}
